export const appInfo = {
  name: "Kaduna State Schools Quality Assurance Authority",
  short: "KSSQAA",
  state: "Kaduna",
  address: "",
  background: '#052918',
  youtubeLink: 'https://www.youtube.com/@kadquality',
};
